"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FileOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M26 8.6L20.4 3A3.7 3.7 0 0018 2H7a2 2 0 00-2 2v24a2 2 0 002 2h18a2 2 0 002-2V11a3.7 3.7 0 00-1-2.4zm-7-4.2l5.6 5.6H19zM25 28H7V4h10v7a1 1 0 001 1h7z"/><path d="M17 16a1 1 0 01-1 1h-6a1 1 0 010-2h6a1 1 0 011 1zM23 24a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1zM23 20a1 1 0 01-1 1H10a1 1 0 010-2h12a1 1 0 011 1z"/>';
var FileOutlineSVG = function FileOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.FileOutlineSVG = FileOutlineSVG;
FileOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FileOutlineSVG);
exports.default = _default;